import React from 'react'
import AppCombobox from '../AppCombobox'

export default function OrganizationScopeSection({
  // Company
  showCompany = true,
  company = '',
  onCompanyChange,
  companyOptions = [],
  showCompanyScope = false,
  companyScope = 'Single',
  onCompanyScopeChange,

  // Branch
  showBranch = true,
  branch = '',
  onBranchChange,
  branchOptions = [],
  showBranchScope = true,
  branchScope = 'Single',
  onBranchScopeChange,

  // Batch
  showBatch = true,
  batch = '',
  onBatchChange,
  batchOptions = [],
  showBatchScope = true,
  batchScope = 'Single',
  onBatchScopeChange,

  // School/College
  showSchool = true,
  school = '',
  onSchoolChange,
  schoolOptions = [],
  showSchoolScope = true,
  schoolScope = 'Single',
  onSchoolScopeChange,
}) {
  return (
    <section className="rounded-3xl border border-outline-variant/30 bg-surface-container-lowest shadow-xs">
      {/* ── Header ── */}
      <div className="border-b border-outline-variant/20 bg-surface-container-low/60 px-6 py-4 rounded-t-3xl flex items-center gap-3">
        <div className="flex h-9 w-9 items-center justify-center rounded-xl bg-amber-500/10 text-amber-600">
          <span className="material-symbols-outlined text-lg">corporate_fare</span>
        </div>
        <div>
          <h2 className="font-display text-base font-bold text-on-surface">
            Organization &amp; Target Scope
          </h2>
          <p className="text-xs text-on-surface-variant">
            Set organizational boundaries and target student batches/schools.
          </p>
        </div>
      </div>

      {/* ── Fields ── */}
      <div className="p-6 md:p-8 flex flex-col gap-5 text-xs">
        
        {/* Company */}
        {showCompany && (
          <div className="grid grid-cols-12 gap-4 items-center">
            <span className="col-span-12 sm:col-span-3 text-xs font-black uppercase tracking-wider text-on-surface-variant">
              Company<span className="text-error font-bold"> *</span>
            </span>
            <div className={`col-span-12 ${showCompanyScope ? 'sm:col-span-6' : 'sm:col-span-9'}`}>
              <AppCombobox
                options={companyOptions}
                value={company}
                onChange={onCompanyChange}
                placeholder="Select Company..."
                triggerClassName="h-10 w-full bg-surface-container-low text-xs font-semibold"
              />
            </div>
            {showCompanyScope && (
              <div className="col-span-12 sm:col-span-3">
                <div className="inline-flex items-center rounded-xl bg-surface-container-high p-1 select-none">
                  <button
                    type="button"
                    onClick={() => onCompanyScopeChange?.('Single')}
                    className={`rounded-lg px-3 py-1 text-xs font-bold transition-all ${
                      companyScope === 'Single'
                        ? 'bg-surface-container-lowest text-primary shadow-xs'
                        : 'text-on-surface-variant hover:text-on-surface'
                    }`}
                  >
                    Single
                  </button>
                  <button
                    type="button"
                    onClick={() => onCompanyScopeChange?.('All')}
                    className={`rounded-lg px-3 py-1 text-xs font-bold transition-all ${
                      companyScope === 'All'
                        ? 'bg-surface-container-lowest text-primary shadow-xs'
                        : 'text-on-surface-variant hover:text-on-surface'
                    }`}
                  >
                    All
                  </button>
                </div>
              </div>
            )}
          </div>
        )}

        {/* Branch */}
        {showBranch && (
          <div className="grid grid-cols-12 gap-4 items-center">
            <span className="col-span-12 sm:col-span-3 text-xs font-black uppercase tracking-wider text-on-surface-variant">
              Branch
            </span>
            <div className={`col-span-12 ${showBranchScope ? 'sm:col-span-6' : 'sm:col-span-9'}`}>
              <AppCombobox
                options={branchOptions}
                value={branch}
                onChange={onBranchChange}
                disabled={showBranchScope && branchScope === 'All'}
                placeholder="Select Branch..."
                triggerClassName="h-10 w-full bg-surface-container-low text-xs font-semibold disabled:opacity-50"
              />
            </div>
            {showBranchScope && (
              <div className="col-span-12 sm:col-span-3">
                <div className="inline-flex items-center rounded-xl bg-surface-container-high p-1 select-none">
                  <button
                    type="button"
                    onClick={() => onBranchScopeChange?.('Single')}
                    className={`rounded-lg px-3 py-1 text-xs font-bold transition-all ${
                      branchScope === 'Single'
                        ? 'bg-surface-container-lowest text-primary shadow-xs'
                        : 'text-on-surface-variant hover:text-on-surface'
                    }`}
                  >
                    Single
                  </button>
                  <button
                    type="button"
                    onClick={() => onBranchScopeChange?.('All')}
                    className={`rounded-lg px-3 py-1 text-xs font-bold transition-all ${
                      branchScope === 'All'
                        ? 'bg-surface-container-lowest text-primary shadow-xs'
                        : 'text-on-surface-variant hover:text-on-surface'
                    }`}
                  >
                    All
                  </button>
                </div>
              </div>
            )}
          </div>
        )}

        {/* Batch */}
        {showBatch && (
          <div className="grid grid-cols-12 gap-4 items-center">
            <span className="col-span-12 sm:col-span-3 text-xs font-black uppercase tracking-wider text-on-surface-variant">
              Batch
            </span>
            <div className={`col-span-12 ${showBatchScope ? 'sm:col-span-6' : 'sm:col-span-9'}`}>
              <AppCombobox
                options={batchOptions}
                value={batch}
                onChange={onBatchChange}
                disabled={showBatchScope && batchScope === 'All'}
                placeholder="Select Batch..."
                triggerClassName="h-10 w-full bg-surface-container-low text-xs font-semibold disabled:opacity-50"
              />
            </div>
            {showBatchScope && (
              <div className="col-span-12 sm:col-span-3">
                <div className="inline-flex items-center rounded-xl bg-surface-container-high p-1 select-none">
                  <button
                    type="button"
                    onClick={() => onBatchScopeChange?.('Single')}
                    className={`rounded-lg px-3 py-1 text-xs font-bold transition-all ${
                      batchScope === 'Single'
                        ? 'bg-surface-container-lowest text-primary shadow-xs'
                        : 'text-on-surface-variant hover:text-on-surface'
                    }`}
                  >
                    Single
                  </button>
                  <button
                    type="button"
                    onClick={() => onBatchScopeChange?.('All')}
                    className={`rounded-lg px-3 py-1 text-xs font-bold transition-all ${
                      batchScope === 'All'
                        ? 'bg-surface-container-lowest text-primary shadow-xs'
                        : 'text-on-surface-variant hover:text-on-surface'
                    }`}
                  >
                    All
                  </button>
                </div>
              </div>
            )}
          </div>
        )}

        {/* School / College */}
        {showSchool && (
          <div className="grid grid-cols-12 gap-4 items-center">
            <span className="col-span-12 sm:col-span-3 text-xs font-black uppercase tracking-wider text-on-surface-variant">
              School/College
            </span>
            <div className={`col-span-12 ${showSchoolScope ? 'sm:col-span-6' : 'sm:col-span-9'}`}>
              <AppCombobox
                options={schoolOptions}
                value={school}
                onChange={onSchoolChange}
                disabled={showSchoolScope && schoolScope === 'All'}
                placeholder="Select School/College..."
                triggerClassName="h-10 w-full bg-surface-container-low text-xs font-semibold disabled:opacity-50"
              />
            </div>
            {showSchoolScope && (
              <div className="col-span-12 sm:col-span-3">
                <div className="inline-flex items-center rounded-xl bg-surface-container-high p-1 select-none">
                  <button
                    type="button"
                    onClick={() => onSchoolScopeChange?.('Single')}
                    className={`rounded-lg px-3 py-1 text-xs font-bold transition-all ${
                      schoolScope === 'Single'
                        ? 'bg-surface-container-lowest text-primary shadow-xs'
                        : 'text-on-surface-variant hover:text-on-surface'
                    }`}
                  >
                    Single
                  </button>
                  <button
                    type="button"
                    onClick={() => onSchoolScopeChange?.('All')}
                    className={`rounded-lg px-3 py-1 text-xs font-bold transition-all ${
                      schoolScope === 'All'
                        ? 'bg-surface-container-lowest text-primary shadow-xs'
                        : 'text-on-surface-variant hover:text-on-surface'
                    }`}
                  >
                    All
                  </button>
                </div>
              </div>
            )}
          </div>
        )}

      </div>
    </section>
  )
}
